import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CustomerSupportLinkDirective } from "@obg/core.customer-support";
import { CoreModule } from "@obg/ngx.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { RouterModule } from "@obg/ngx.router";
import { GlobalUiModule } from "@obg/ngx.ui.global";

import { CoreUiModule } from "../module";

import { CompactFooterComponent } from "./compact-footer.component";

const DIRECTIVES = [CompactFooterComponent];

@NgModule({
	imports: [
		CoreModule,
		CoreUiModule,
		CommonModule,
		GlobalUiModule,
		CoreContentModule,
		RouterModule,
		CustomerSupportLinkDirective,
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class CompactFooterModule {}
